import { useDispatch, useSelector } from 'react-redux';

/**
 * Typed dispatch hook — use this instead of plain useDispatch
 * throughout the app for consistency.
 */
export const useAppDispatch = () => useDispatch();

/**
 * Typed selector hook — use this instead of plain useSelector
 * throughout the app for consistency.
 *
 * @example
 * const theme = useAppSelector((state) => state.ui.theme);
 */
export const useAppSelector = useSelector;
